<template>
  <div v-if="contact">

    <h2 class="mb-4 fw-bold">
      {{ contact.title }}
    </h2>

    <div class="mb-3">
      <strong>Email:</strong>
      <a :href="`mailto:${contact.email}`">
        {{ contact.email }}
      </a>
    </div>

    <div class="mb-3" v-if="contact.phone">
      <strong>Telefono:</strong>
      {{ contact.phone }}
    </div>

    <div v-if="contact.social">
      <h5 class="mt-4">Seguici</h5>

      <div class="d-flex gap-3 mt-2">

        <a
          v-if="contact.social.instagram"
          :href="contact.social.instagram"
          target="_blank"
        >
          Instagram
        </a>

        <a
          v-if="contact.social.linkedin"
          :href="contact.social.linkedin"
          target="_blank"
        >
          LinkedIn
        </a>

      </div>

    </div>

  </div>
</template>

<script>
export default {

  name: 'ContactPage',

  props: ['pages'],

  computed: {
    contact () {
      return this.pages?.contact || null
    }
  }

}
</script>
